import styled from "styled-components";

import metrics from "../../../../styles/metrics";
import colors from "../../../../styles/colors";

export const ClockContainer = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: row;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: ${metrics.basePadding}px;
  color: ${colors.text.white};
  font-size: 1.2em;
`;

export const ClockIcon = styled.div<{ open: boolean }>`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  background: ${props =>
    props.open ? colors.clock.open : colors.clock.closed};
  margin-right: 10px;
  transition: background-color 0.3s ease;
`;
